import alibaba from '@lobehub/icons-static-svg/icons/alibaba-color.svg';
import bytedance from '@lobehub/icons-static-svg/icons/bytedance-color.svg';
import claude from '@lobehub/icons-static-svg/icons/claude-color.svg';
import claudecode from '@lobehub/icons-static-svg/icons/claudecode-color.svg';
import chatglm from '@lobehub/icons-static-svg/icons/chatglm-color.svg';
import deepseek from '@lobehub/icons-static-svg/icons/deepseek-color.svg';
import doubao from '@lobehub/icons-static-svg/icons/doubao-color.svg';
import fal from '@lobehub/icons-static-svg/icons/fal.svg';
import flux from '@lobehub/icons-static-svg/icons/flux.svg';
import gemini from '@lobehub/icons-static-svg/icons/gemini-color.svg';
import google from '@lobehub/icons-static-svg/icons/google-color.svg';
import grok from '@lobehub/icons-static-svg/icons/grok.svg';
import ideogram from '@lobehub/icons-static-svg/icons/ideogram.svg';
import jimeng from '@lobehub/icons-static-svg/icons/jimeng-color.svg';
import kling from '@lobehub/icons-static-svg/icons/kling-color.svg';
import luma from '@lobehub/icons-static-svg/icons/luma-color.svg';
import midjourney from '@lobehub/icons-static-svg/icons/midjourney.svg';
import minimax from '@lobehub/icons-static-svg/icons/minimax-color.svg';
import moonshot from '@lobehub/icons-static-svg/icons/moonshot.svg';
import newapi from '@lobehub/icons-static-svg/icons/newapi-color.svg';
import ollama from '@lobehub/icons-static-svg/icons/ollama.svg';
import openai from '@lobehub/icons-static-svg/icons/openai.svg';
import opencode from '@lobehub/icons-static-svg/icons/opencode.svg';
import hermesagent from '@lobehub/icons-static-svg/icons/hermesagent.svg';
import pixverse from '@lobehub/icons-static-svg/icons/pixverse-color.svg';
import qwen from '@lobehub/icons-static-svg/icons/qwen-color.svg';
import replicate from '@lobehub/icons-static-svg/icons/replicate.svg';
import runway from '@lobehub/icons-static-svg/icons/runway.svg';
import sora from '@lobehub/icons-static-svg/icons/sora-color.svg';
import siliconcloud from '@lobehub/icons-static-svg/icons/siliconcloud-color.svg';
import spark from '@lobehub/icons-static-svg/icons/spark-color.svg';
import suno from '@lobehub/icons-static-svg/icons/suno.svg';
import tencentcloud from '@lobehub/icons-static-svg/icons/tencentcloud-color.svg';
import vidu from '@lobehub/icons-static-svg/icons/vidu-color.svg';
import volcengine from '@lobehub/icons-static-svg/icons/volcengine-color.svg';
import wenxin from '@lobehub/icons-static-svg/icons/wenxin-color.svg';
import xiaomimimo from '@lobehub/icons-static-svg/icons/xiaomimimo.svg';

export const PLATFORM_ICONS = {
  alibaba,
  bytedance,
  claude,
  claudecode,
  chatglm,
  deepseek,
  doubao,
  fal,
  flux,
  gemini,
  google,
  grok,
  ideogram,
  jimeng,
  kling,
  luma,
  midjourney,
  minimax,
  moonshot,
  newapi,
  ollama,
  openai,
  opencode,
  hermesagent,
  pixverse,
  qwen,
  replicate,
  runway,
  sora,
  siliconcloud,
  spark,
  suno,
  tencentcloud,
  vidu,
  volcengine,
  wenxin,
  xiaomimimo,
};

export function platformIcon(platform) {
  return PLATFORM_ICONS[platform?.icon] || newapi;
}
